'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var CONSTANTS = require('./constants');

var logger = require('./utils').logger;

var unwantEvent = function unwantEvent(c) {
  return "unwant:".concat(c);
};

var blockEvent = function blockEvent(c) {
  return "block:".concat(c);
};
/**
 * Internal module used to track events about incoming blocks,
 * wants and unwants.
 *
 * @param {PeerId} peerId
 * @private
 */


var Notifications =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Notifications, _EventEmitter);

  function Notifications(peerId) {
    var _this;

    _classCallCheck(this, Notifications);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Notifications).call(this));

    _this.setMaxListeners(CONSTANTS.maxListeners);

    _this._log = logger(peerId, 'notif');
    _this._unwantListeners = {};
    _this._blockListeners = {};
    return _this;
  }
  /**
   * Signal the system that we received `block`.
   *
   * @param {Block} block
   * @return {void}
   */


  _createClass(Notifications, [{
    key: "hasBlock",
    value: function hasBlock(block) {
      var str = "block:".concat(block.cid.buffer.toString());

      this._log(str);

      this.emit(str, block);
    }
    /**
     * Signal the system that we are waiting to receive the
     * block associated with the given `cid`.
     *
     * @param {CID} cid
     * @param {function(Block)} onBlock - called when the block is received
     * @param {function()} onUnwant - called when the block is unwanted
     * @returns {void}
     */

  }, {
    key: "wantBlock",
    value: function wantBlock(cid, onBlock, onUnwant) {
      var _this2 = this;

      var cidStr = cid.buffer.toString();

      this._log("wantBlock:".concat(cidStr));

      this._unwantListeners[cidStr] = function () {
        _this2._log("manual unwant: ".concat(cidStr));

        _this2._cleanup(cidStr);

        onUnwant();
      };

      this._blockListeners[cidStr] = function (block) {
        _this2._cleanup(cidStr);

        onBlock(block);
      };

      this.once(unwantEvent(cidStr), this._unwantListeners[cidStr]);
      this.once(blockEvent(cidStr), this._blockListeners[cidStr]);
    }
    /**
     * Signal that the block is not wanted anymore.
     *
     * @param {CID} cid - the CID of the block that is not wanted anymore.
     * @returns {void}
     */

  }, {
    key: "unwantBlock",
    value: function unwantBlock(cid) {
      var str = "unwant:".concat(cid.buffer.toString());

      this._log(str);

      this.emit(str);
    }
    /**
     * Internal method to clean up once a block was received or unwanted.
     *
     * @private
     * @param  {string} cidStr
     * @returns {void}
     */

  }, {
    key: "_cleanup",
    value: function _cleanup(cidStr) {
      if (this._unwantListeners[cidStr]) {
        this.removeListener(unwantEvent(cidStr), this._unwantListeners[cidStr]);
        delete this._unwantListeners[cidStr];
      }

      if (this._blockListeners[cidStr]) {
        this.removeListener(blockEvent(cidStr), this._blockListeners[cidStr]);
        delete this._blockListeners[cidStr];
      }
    }
  }]);

  return Notifications;
}(EventEmitter);

module.exports = Notifications;